import React, {useContext} from "react";
import {Box, Card, Stack, Typography} from "@mui/material";
import {
  CONTEXT_ACTION_TYPE,
  DataStoreContext,
  initialState,
  ObjectRegisterPayload
} from "../../contexts/OperatingEnvironmentContext";
import useMutation from "../../../../hooks/useMutation";
import Pjdb1ImputEx from "../../../../components/inputs/Pjdb1ImputEx";
import WithLabel from "../forms/WithLabel";
import Pjdb1FileSelect from "../../../../components/inputs/Pjdb1FileSelect";
import Pjdb1Button from "../../../../components/inputs/Pjdb1Button";
import {fileUploade, registerObject} from "../../../../utils/awsAmplifyUtil";

export default function ObjectRegisterStep() {
  const {state, dispatch} = useContext(DataStoreContext);
  const [fileErr, setFileErr] = React.useState({err: false, errMsg: ""});
  const {mutate, formRef, isLoading, clear} = useMutation({
    enableConfirm: false,
    successMsg: '登録完了',
    mutationFn: async () => {
      const fileUploadedRes = await fileUploade(state.objectRegister.inputs.files.find(() => true) as File);
      if (!fileUploadedRes.isSuccess || fileUploadedRes.data === undefined) {
        return 'ファイルのアップロードに失敗しました。';
      }

      const registeredObjectRes = await registerObject({
        pathParams: {version: 'object-user'},
        body: {"s3-uri": fileUploadedRes.data},
      })
      return registeredObjectRes.isSuccess;
    },
    validate: () => {
      console.log("validate");
      if (state.objectRegister.inputs.files.length === 0) {
        setFileErr({err: true, errMsg: "ファイルを選択してください。"});
        return false;
      }
      return true;
    },
    onClear: () => {
      console.log("onClear");
      dispatch({
        type: CONTEXT_ACTION_TYPE.OBJECT_REGISTER,
        payload: initialState.objectRegister satisfies ObjectRegisterPayload
      });
      setFileErr({err: false, errMsg: ""});
    }
  });

  return (
    <Card sx={{p: 3, width: '100%'}}>
      <Stack gap={4}>
        <Box display='flex' flexWrap='wrap' gap={2} alignItems='flex-end' justifyContent='space-between'>
          <Typography variant="h6">環境オブジェクト</Typography>
          <Pjdb1ImputEx/>
        </Box>

        <form ref={formRef}>
          <Stack gap={2}>
            <WithLabel label='オブジェクトファイル'>
              <Pjdb1FileSelect
                label='オブジェクトファイル'
                name='file'
                value={state.objectRegister.inputs.files}
                onChange={(_, files) => {
                  dispatch({
                    type: CONTEXT_ACTION_TYPE.OBJECT_REGISTER,
                    payload: {inputs: {files}} satisfies ObjectRegisterPayload
                  });
                }}
                multiple={false}
                accept={{
                  'application/zip': ['.zip'],
                }}
                err={fileErr.err}
                errMsg={fileErr.errMsg}
                xs={8}
                toolTip={(
                  <Box whiteSpace='pre-wrap'>{`
以下のフォルダ構成のzipファイルをアップロードする。
*.zip
CMakeLists.txt
package.xml
object/
  <object-id>/
    *.urdf
    meshes/
      visual/
        *.obj *.mtl *.jpeg
      collision/
        *.stl
                  `}</Box>
                  )}
                />
            </WithLabel>
          </Stack>
        </form>

        <Box component="section" sx={{textAlign: "center"}}>
          <Pjdb1Button
            label="クリア"
            variant="contained"
            color="inherit"
            isLoading={isLoading}
            sx={{m: 2}}
            onClick={clear}
          />
          <Pjdb1Button
            label="環境オブジェクトを登録"
            variant="contained"
            color="primary"
            isLoading={isLoading}
            sx={{m: 2}}
            onClick={() => {
              mutate().catch(console.error)
            }}
          />
        </Box>
      </Stack>
    </Card>
);
}
